<template>
  <div style="width: 90%; margin-left: 5%">
    <div class="story">
      <div class="img-box">
        <img src="../../src/assets/basketballActivities/r.jpg" alt="" />
      </div>
      <div class="years-btn">
        <el-button
          v-for="(item, index) in yearnum"
          @click="getHighlight, yearBtn(item.id, item)"
          :key="index"
          type="primary"
          :class="[
            {
              'active-schedule':
                bothactiveSchedules.id === item.id && headType === '1'
            },
            {
              'active-schedule-f':
                bothactiveSchedules.id === item.id && headType === '2'
            },
            { 'schedule-item-f': headType === '2' }
          ]"
          >{{ item.type }}</el-button
        >
      </div>
      <!-- pull down -->
      <div class="pulldown" :class="{ 'option-f': headType === '2' }">
        <el-select
          class="gamelist"
          @change="getHighlight"
          :no-data-text="$t('home.nodata')"
          v-model="schedule"
          :placeholder="$t('schedule.hot')"
          :popper-append-to-body="false"
        >
          <el-option
            v-for="item in match"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
            <span
              @click="gameName(item.value)"
              style="text-align: left;display:block;"
              >{{ item.label }}</span
            >
          </el-option>
        </el-select>
        <el-select
          @change="getHighlight"
          :no-data-text="$t('home.nodata')"
          v-model="team_id"
          :placeholder="$t('schedule.select')"
          :popper-append-to-body="false"
        >
          <el-option
            v-for="item in teamsInfo"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
            <span style="text-align: left;display:block;" name="roundname">{{
              item.name
            }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="more-contents" v-if="roundlist.length > 0">
        <div class="highlight-box">
          <!-- <p class="round-num">Round{{ roundlist[0].schedule_round.round }}</p> -->

          <div class="more-box">
            <div
              class="more-content"
              v-for="(item, index) in roundlist"
              :key="index"
            >
              <div class="pic-txt" v-loading="lighightLoading">
                <div class="pic">
                  <el-image
                    @click="aubumList(item.id)"
                    class="img"
                    :src="item.temp_path_url"
                    alt=""
                  />
                </div>
                <p v-if="item.team1_name || item.team2_name">
                  {{ item.team1_name }} VS {{ item.team2_name }}
                </p>
                <p>{{ item.schedule.name }}</p>
                <p>{{ item.date }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else v-loading="lighightLoading">
        <div class="no-data">{{ $t("home.nodata") }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { BasketballApi } from "../api/basketball";

import { mapState } from "vuex";

export default {
  components: {
    // morestories
    // MoreCom
  },
  data() {
    return {
      bothactiveSchedules: { type: "2024-25", id: 2024 },
      label: "",
      values: "",
      lighightLoading: true,
      roundlist: "",
      hightPic: [],
      schedule_id: "",
      schedule_id_girl: "",
      year: 2024,
      match: "",
      schedule_round: "",
      yearNum: [
        { id: 2024, type: "2024-25" },
        { id: 2023, type: "2023-24" },
        { id: 2022, type: "2022-23" },
        { id: 2021, type: "2021-22" },
        { id: 2020, type: "2020-21" }
      ],
      roundNum: "",
      roundname: "",
      firstRoundId: "",
      album: "a",
      teamsInfo: "",
      team_id: ""
    };
  },
  watch: {
    headType() {
      this.getHighlight();
      this.getScheduleAlbum();
      this.getRoundsList();
    }
  },
  computed: {
    ...mapState(["headType"]),
    yearnum() {
      return this.headType == "1"
        ? this.yearNum.slice(0, 4)
        : this.yearNum.slice(0, 3);
    },
    schedule: {
      // eslint-disable-next-line vue/return-in-computed-property
      get() {
        if (this.headType == "1") {
          if (this.schedule_id === "") {
            return "All";
          }
          return this.schedule_id;
        }
        if (this.headType == "2") {
          if (this.schedule_id_girl == "") {
            return "All";
          }
          return this.schedule_id_girl;
        }
      },
      set(newValue) {
        return newValue;
      }
    },
    scheduleIdType() {
      // if (this.schedule_id_girl !== 15 || this.schedule_id_girl !== 16) {
      //   return true;
      // }
      return false;
    }
  },
  methods: {
    aubumList(id) {
      this.$router.push({
        path: "highlights-album",
        query: { id: id, type: this.headType }
      });
    },
    gameName(id) {
      if (this.headType == "1") {
        this.schedule_id = id;
        if (id === "All") {
          this.schedule_id = "";
        }
      } else if (this.headType == "2") {
        this.schedule_id_girl = id;
      }
      this.values = "";
      this.roundId = "";
      this.roundId_girl = "";
      this.getHighlight();
      this.getRoundsList();
    },
    yearBtn(id, item) {
      this.bothactiveSchedules = item;
      this.year = id;
      this.schedule_id = "";
      this.schedule_id_girl = "";
      this.headType == "1" ? this.schedule_id : this.schedule_id_girl;
      this.values = "";
      this.roundId = "";
      this.roundId_girl = "";
      this.getRoundsList();
      this.getScheduleAlbum();
      this.getHighlight();
      this.TeamInfo();
    },
    getHighlight() {
      this.lighightLoading = true;
      this.round_id = this.headType == "1" ? this.roundId : this.roundId_girl;
      const data = {
        schedule_id:
          this.headType == "2" ? this.schedule_id_girl : this.schedule_id,
        year: this.year,
        type: this.headType == "2" ? "w" : "m",
        schedule_round_id: this.values == "all" ? "" : this.values,
        team_id: this.team_id === "all" ? "" : this.team_id
      };
      BasketballApi.getHighlight(data).then(res => {
        this.roundlist = res;
        this.lighightLoading = false;
      });
    },
    //获取Round列表
    getRoundsList() {
      BasketballApi.getRoundsList(
        this.headType == "1" ? this.schedule_id : this.schedule_id_girl,
        this.headType == "2" ? "w" : "m",
        this.year
      ).then(res => {
        let arr = [{ label: "ALL", value: "all" }];
        res.schedule_rounds.forEach(item => {
          let obj = new Object();
          obj.value = item.id;
          obj.label = "Round" + item.round;
          arr.push(obj);
        });
        this.roundNum = arr;
      });
    },
    // get team list
    TeamInfo() {
      this.teamloading = true;
      BasketballApi.getTeams({
        year: this.year,
        type: this.headType === "1" ? "m" : "w"
      }).then(result => {
        this.teamsInfo = result;
        this.teamsInfo.unshift({ id: "all", name: "All" });
        this.teamloading = false;
      });
    },
    // 获取赛程分类
    getScheduleAlbum() {
      BasketballApi.getScheduleAlbum(
        this.headType == "1" ? "m" : "w",
        this.year,
        this.album
      ).then(res => {
        let arr = [];
        res.forEach(item => {
          let obj = new Object();
          obj.value = item.id;
          obj.label = item.name;
          arr.push(obj);
        });

        this.match = arr;
        this.match.unshift({ id: "all", label: "All", value: "All" });
        // removing learning experience
        // if learning experience is no longer the last of element, change the method
        this.match.pop();
      });
    }
  },
  created() {
    this.getHighlight();
    this.getScheduleAlbum();
    this.getRoundsList();
    this.TeamInfo();
  }
};
</script>
<style lang="scss">
.a {
  background: #000;
}

.story {
  .el-select-dropdown {
    .popper__arrow {
      display: none;
    }
  }
  .pulldown {
    width: 100%;
    height: 40px;
    margin: 50px 0px;
    .el-select {
      width: 203px;
      border: none;
      .el-input {
        .el-select__caret {
          color: #318bc8;
        }
        .el-input__inner {
          height: 47px;
          border: 1px solid #318bc8;
          border-radius: 15px;
          color: #318bc8 !important;
        }
      }
      .el-select-dropdown__item.selected {
        color: #318bc8;
      }
    }
    .gamelist {
      margin-right: 20px;
    }
    @media screen and (max-width: 768px) {
      .el-select {
        margin-bottom: 20px;
      }
      .gamelist {
        margin-right: 0px;
      }
    }
  }
  .option-f {
    .el-select {
      .el-input {
        .el-select__caret {
          color: #b9a2c9;
        }
        .el-input__inner {
          border: 1px solid #b9a2c9;
          border-radius: 14.5px;
          color: #b9a2c9 !important;
        }
      }
      .el-select-dropdown__item.selected {
        color: #b9a2c9;
      }
    }
  }
  .years-btn {
    margin-top: 30px;
    .el-button {
      background-color: #fff;
      color: #318bc8;
    }
    .el-button:hover {
      background: #318bc8;
      color: #fff;
    }
  }
  .el-image__inner {
    object-fit: cover;
    object-position: center;
  }
}
</style>
<style lang="scss" scoped>
.story {
  .img-box {
    margin-top: 1%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .years-btn {
    text-align: left;
    .active-schedule {
      background: #5e98ca;
      color: #fff;
    }
    .schedule-item-f {
      border: 2px solid #b9a2c9;
      color: #836099;
    }
    .active-schedule-f {
      background: #b9a2c9;
      color: #fff;
    }
  }
  .more-contents {
    display: flex;
    .round {
      display: flex;
      flex-direction: column;
      width: 15%;
      text-align: right;
      p {
        margin-top: 70px;
        height: 100%;
        height: 408px;
        font-size: 16px;
        font-weight: 600;
        color: #318bc8;
        width: auto;
        text-align: left;
      }
    }
    .highlight-box {
      width: 100%;
      display: flex;
      border-bottom: 2px solid #dfe8f7;
      margin-top: 70px;
      .more-box {
        width: 100%;
        display: flex;
        border-radius: 10px;
        margin-bottom: 30px;
        padding-bottom: 30px;
        flex-wrap: wrap;
        .more-content {
          margin-left: 20px;
          width: 23%;
          margin-top: 40px;
          .pic-txt {
            width: 100%;
            .pic {
              width: 100%;
              height: 200px;
              border-radius: 10px;
              margin-bottom: 10px;
              overflow: hidden;
              .img {
                width: 100%;
                height: 100%;
                cursor: pointer;
                transition: all 0.6s;
                img {
                  background: #000;
                }
              }
              .img:hover {
                transform: scale(1.1);
              }
            }
            p {
              font-size: 17px;
              font-weight: 600;
              color: #2d3b51;
              text-align: left;
              margin-left: 10px;
            }
          }
        }
      }
      @media screen and (max-width: 768px) {
        .more-box {
          flex-direction: column;
          .more-content {
            width: 95%;
            margin-left: 2.5%;
            .pic-txt {
              p {
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
  .no-data {
    height: 400px !important;
    font-size: 40px;
    color: #dfe8f7;
    font-weight: 600;
    margin-top: 80px;
    border-bottom: 2px solid #dfe8f7;
  }
}
</style>
